import A1 from '../image/django.png';
import A2 from '../image/tik.jpeg';
import A3 from '../image/snake.jpeg';
import A4 from '../image/rest.png';

import A5 from '../image/cyptro.jpeg';
import A6 from '../image/sure.png';

 export const PROJ=[
    {
        id:'React & Django',
        name:'E-Commerce Website',
        des:'I build e-commerce website with using lastest technology like React, Django and Bootstrap. It contain all feature like cart, payment gateway, login and sign up page and many more...   ',
        pos:0,
        img:A1
    },
    {
        id:'Android',
        name:'Tic Tac Toe ',
        des:'I recently build a android game known as Tic Tac Toe. It have function like playing with computer, Two player mode. Still more to add...',
        pos:1,
        img:A2
    },
    {
        id:'Python',
        name:'Snake Game',
        des:'I build a snake Game in python. It is classic snake game with some modification like PowerUp your snake, Slow speed of snake with special fruits and many more....',
        pos:0,
        img:A3
    },
    {
        id:3,
        name:'Restraunt Website',
        des:'I build a Website for a Restraunt in a React. It has function like a booking table online and still more function to add....  ',
        pos:1,
        img:A4
    },
    {
        id:4,
        name:'Crypto Portfolio',
        des:'I used api for get data about crypto current and then python program calculate your total profit.',
        pos:0,
        img:A5
    },
    {
        id:5,
        name:'Website For StartUp',
        des:'I aslo build website for startup known as Sure Staff. I have work experience with a team and Work together.',
        pos:1,
        img:A6
    },
    
];